import SendInvitation from "../../components/SendInvitation";
import React, { useCallback, useState } from "react";
import { useNavigation } from "@react-navigation/native";
import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../../navigations/RootNavigation";
import { useI18n } from "../../hooks/i18n-hooks";
import { useSnackbar } from "../../hooks/snackbar";
import VStack from "../../ui_atoms/VStack";
import ScreenCard from "../ScreenCard";
import { ButtonProps } from "../../components/Button";

type SendInvitationScreenProps = StackScreenProps<RootStackParamList, "SendInvitation">;

const SendInvitationScreen = () => {
    const navigation = useNavigation<SendInvitationScreenProps["navigation"]>();
    const i18n = useI18n();
    const { showSnackbar } = useSnackbar();
    const onSuccess = useCallback(() => {
        showSnackbar({
            text: i18n.t(`invitation.action_result.sent.success`),
            mode: "success",
        });
        navigation.popToTop();
    }, [i18n, navigation, showSnackbar]);

    const [buttonProps, setButtonProps] = useState<Partial<ButtonProps>>();

    return (
        <ScreenCard
            buttons={[
                {
                    title: i18n.t("invitation.send.sendButton"),
                    buttonMode: "secondary",
                    size: "large",
                    ...buttonProps,
                },
            ]}
        >
            <VStack h={1 / 2}>
                <SendInvitation onSuccess={onSuccess} setButtonProps={setButtonProps} />
            </VStack>
        </ScreenCard>
    );
};

export default SendInvitationScreen;
